import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PPartialListComponent } from './p-partial-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
@NgModule({
    declarations: [PPartialListComponent],
    imports: [CommonModule, MatTooltipModule],
    exports: [PPartialListComponent]
})
export class PPartialListModule {}
